import React, { useContext, useState, useEffect } from "react";
import PropTypes from "prop-types";
import Popover from "../PopoverComment/PopoverComment";
import { sections, useEventComments } from "../../hooks/useEventComments";
import { UserContext } from "../../UserContext";

// FIXME checkout https://mui.com/components/use-media-query/#migrating-from-withwidth
const withWidth = () => (WrappedComponent) => (props) =>
  <WrappedComponent {...props} width="xs" />;

const PopoverButton = ({ type, additionalFieldIds = [] }) => {
  const { fieldId, sectionId, eventId } = type;
  const { comments, useAddComment, useMarkCommentsRead } =
    useEventComments(eventId);
  const [isOpen, setIsOpen] = useState(false);
  const {
    featureFlags: { mentions: hasMentions },
  } = useContext(UserContext);
  const sectionComments = comments
    .flatMap((c) => c.comments)
    .filter(
      (c) =>
        c.sectionId === sectionId &&
        (c.fieldId === fieldId || additionalFieldIds.includes(c.fieldId))
    )
    .sort((a, b) => -b?.recAddedDate?.localeCompare(a?.recAddedDate))
    .map((c) => {
      if (!additionalFieldIds.includes(sections.financial.paymentFieldId)) {
        return c;
      }
      return {
        ...c,
        content: (c?.content || "").replace("[Payment comment]\r\n", ""),
      };
    });

  const [lastComment] =
    sectionComments?.length > 0 && hasMentions
      ? [type]
          .concat(sectionComments)
          .filter((c) => c?.fieldId === fieldId)
          .slice(-1)
      : [type];

  useEffect(() => {
    if (!isOpen) {
      return;
    }
    const unreadCommentIds = sectionComments
      .filter((c) => !c?.isArchived && c?.isCatererReply)
      .map((c) => c?.id);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useMarkCommentsRead(unreadCommentIds);
  }, [isOpen, sectionComments, useMarkCommentsRead]);
  return (
    <Popover
      type={lastComment}
      comments={sectionComments}
      onAddComment={useAddComment}
      onOpen={(state) => setIsOpen(state)}
    />
  );
};

PopoverButton.propTypes = {
  width: PropTypes.string.isRequired,
};
export default withWidth()(PopoverButton);
